import React from 'react';
import { Box, MenuItem, Tooltip } from '@mui/material';
import { TextInput, SelectInput } from '@/shared/components/forms';
import { useRoles } from '@/features/researchers/hooks/useRoles';
import { useTranslation } from 'react-i18next';
import { CreateResearcherDto, Researcher } from '@aphp-ema/common/researchers';
import { UseFormReturnType } from '@refinedev/react-hook-form';
import { HttpError } from '@refinedev/core';

export interface UserCreateFormProps {
  form: UseFormReturnType<Researcher, HttpError, CreateResearcherDto>;
  hideRole?: boolean;
}

export const ResearcherForm: React.FC<UserCreateFormProps> = ({
  form,
  hideRole,
}) => {
  const roles = useRoles();
  const { t } = useTranslation();

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        pt: 1,
      }}
    >
      <TextInput
        form={form}
        name="firstName"
        label={t('pages.users.fields.firstName')}
        required
        autoComplete="given-name"
        autoFocus
      />
      <TextInput
        form={form}
        name="lastName"
        label={t('pages.users.fields.lastName')}
        required
        autoComplete="family-name"
      />
      <TextInput
        form={form}
        name="email"
        label={t('pages.users.fields.email')}
        required
        autoComplete="email"
      />
      {!hideRole && (
        <SelectInput
          form={form}
          name="role"
          required
          label={t('pages.users.fields.roles')}
        >
          {roles.map((role) => (
            <MenuItem key={role.id} value={role.value}>
              <Tooltip
                title={role.description || 'No description available'}
                arrow
                placement="right"
              >
                <Box>{role.name}</Box>
              </Tooltip>
            </MenuItem>
          ))}
        </SelectInput>
      )}
    </Box>
  );
};
